import { trackEventByName } from './analytics';

const CATEGORY_HEADER = 'header';
const CATEGORY_FOOTER = 'footer';
const CATEGORY_HOME = 'home';

const download = {
  ios_download_button_clicked: (section) =>
    trackEventByName('ios_download_button_clicked', {
      category: 'download',
      section,
    }),
  android_download_button_clicked: (section) =>
    trackEventByName('android_download_button_clicked', {
      category: 'download',
      section,
    }),
};

const header = {
  logoClick: () => trackEventByName('header_logo_click', { category: CATEGORY_HEADER }),
  mobileMenuToggleClick: () => trackEventByName('header_mobile_menu_toggle_click', { category: CATEGORY_HEADER }),
  navClick: (sectionId) => trackEventByName('header_nav_click', { category: CATEGORY_HEADER, section_id: sectionId }),
};

const footer = {
  logoClick: () => trackEventByName('footer_logo_click', { category: CATEGORY_FOOTER }),
  emailClick: () => trackEventByName('footer_email_click', { category: CATEGORY_FOOTER }),
  navClick: (sectionId) => trackEventByName('footer_nav_click', { category: CATEGORY_FOOTER, section_id: sectionId }),
};

const landing = {};

const home = {
  bannerVideoPlayClick: () => trackEventByName('home_banner_video_play_click', { category: CATEGORY_HOME }),
  bannerVideoModalCloseClick: () =>
    trackEventByName('home_banner_video_modal_close_click', { category: CATEGORY_HOME }),
};

const features = {
  sliderArrowNextClick: () => trackEventByName('key_features_slider_arrow_next_click', { category: 'key_features' }),
  sliderArrowPrevClick: () => trackEventByName('key_features_slider_arrow_prev_click', { category: 'key_features' }),
};

const aboutUs = {
  videoPlayClick: () => trackEventByName('about_us_video_play_click', { category: 'about_us' }),
  videoModalCloseClick: () => trackEventByName('about_us_video_modal_close_click', { category: 'about_us' }),
};

const textSlider = {
  sliderSwipe: (activeIndex) =>
    trackEventByName('text_slider_swipe', { category: 'text_slider', slide_index: activeIndex }),
};

const faq = {
  tabClick: (tabId) => trackEventByName('faq_tab_click', { category: 'faq', tab_id: tabId }),
  questionClick: (sectionId, questionIndex) =>
    trackEventByName('faq_question_click', {
      category: 'faq',
      section_id: sectionId,
      question_index: questionIndex,
    }),
};

const interfaceSection = {
  sliderArrowNextClick: () => trackEventByName('interface_slider_arrow_next_click', { category: 'interface' }),
  sliderArrowPrevClick: () => trackEventByName('interface_slider_arrow_prev_click', { category: 'interface' }),
};

const scroll = {
  sectionReached: (sectionId) => {
    switch (sectionId) {
      case 'home':
        trackEventByName('home_scrolled', { category: 'scroll' });
        break;
      case 'key_features':
        trackEventByName('features_scrolled', { category: 'scroll' });
        break;
      case 'about_us':
        trackEventByName('approved_for_kids_scrolled', { category: 'scroll' });
        break;
      case 'text_list':
        trackEventByName('text_list_scrolled', { category: 'scroll' });
        break;
      case 'services':
        trackEventByName('story_scrolled', { category: 'scroll' });
        break;
      case 'how_it_works':
        trackEventByName('how_it_works_scrolled', { category: 'scroll' });
        break;
      case 'music':
        trackEventByName('music_scrolled', { category: 'scroll' });
        break;
      case 'reviews':
        trackEventByName('reviews_scrolled', { category: 'scroll' });
        break;
      case 'faq':
        trackEventByName('faq_scrolled', { category: 'scroll' });
        break;
      case 'interface':
        trackEventByName('interface_scrolled', { category: 'scroll' });
        break;
      case 'download':
        trackEventByName('download_scrolled', { category: 'scroll' });
        break;
      case 'footer':
        trackEventByName('footer_scrolled', { category: 'scroll' });
        break;
      default:
        trackEventByName('other_section_scrolled', { category: 'scroll', section_id: sectionId });
    }
  },
};

const ga4Events = {
  header,
  footer,
  landing,
  home,
  download,
  features,
  aboutUs,
  textSlider,
  faq,
  interfaceSection,
  scroll,
};

export default ga4Events;
